import Arrow from 'assets/images/arrowBack.svg';
import { TFunction } from 'i18next';
import Box from '@mui/material/Box';
import { Tooltip } from '../../../Tooltip/Tooltip';
import { palette } from 'theme/palette';
import { pxToRem } from 'src/common/utils/fonts';
import { useTranslation } from 'react-i18next';

export type SortingIndicatorProps = {
  direction?: 'asc' | 'desc' | null;
  'data-testid'?: string;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
};

const getSortingIndicatorLabel = (direction: 'asc' | 'desc' | null | undefined, t: TFunction) => {
  if (direction === 'asc') {
    return t('common.asc');
  }

  return direction === 'desc' ? t('common.desc') : t('common.toSort');
};

export const SortingIndicator = ({ direction, ...props }: SortingIndicatorProps) => {
  const { t } = useTranslation();
  const style = {
    transform: direction === 'desc' ? 'rotate(270deg)' : 'rotate(90deg)',
    transition: 'transform 150ms ease',
  };

  const label = getSortingIndicatorLabel(direction, t);

  return (
    <Box
      aria-label={label}
      {...props}
      role="button"
      sx={{
        display: 'inline-flex',
        '&:hover': {
          background: palette.border,
          borderRadius: '100%',
        },
      }}
    >
      <Tooltip
        showArrow={true}
        placement={'top'}
        enterDelay={1000}
        enterTouchDelay={1000}
        enterNextDelay={1000}
        variant="dark"
        title={
          !direction || direction === 'desc'
            ? t('common.sortByAscending')
            : t('common.sortByDescending')
        }
      >
        <Arrow
          style={style}
          width={pxToRem(16)}
          height={pxToRem(16)}
          role="img"
          viewBox="0 0 24 24"
        />
      </Tooltip>
    </Box>
  );
};
